// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store.js'
import BootstrapVue from 'bootstrap-vue'

import './assets/css/main.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/material.css';
import Vuelidate from "vuelidate";
import i18n from './i18n'
import 'vue-awesome/icons/flag'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

const options = {
    toast: {
      position: SnotifyPosition.centerTop
    }
  }
const fb = require('./firebaseConfig.js')

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.component('icon', Icon)
Vue.use(Snotify, options)
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
Vue.use(ElementUI, { locale })


let app;

fb.auth.onAuthStateChanged(user => {
  if (!app) {
      app = new Vue({
        el: '#app',
        router,
        store,
        i18n,
        render: h => h(App)
      })
  }
})





// WEBPACK FOOTER //
// ./src/main.js